import Vue from 'vue'

export async function getGrupos(context, [access_token, con_loading]) {
    
    try {
        if (access_token) {
            if (con_loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/grupos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
           
            context.commit('grupos/setGrupos', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading){
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function crearGrupo(context, [access_token, modelGrupo]) {
    try {

        if (access_token) {
           // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/grupos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelGrupo
            })
         
          
        }

    } catch (e) {
    } finally {
     //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateGrupo(context, [access_token, modelGrupo]) {
    try {
        if (access_token) {
          
            const response = await Vue.axios({
                method: 'PUT',
                url: '/grupos/' + modelGrupo.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelGrupo
            })
            if (response.status == 200) {
                context.commit('grupos/actListGrupos', response.data.data, { root: true })
               }
           return response;
          
        }

    } catch (e) {
    } finally {
     // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarGrupo(context, [access_token, grupo_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/grupos/' + grupo_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

          
           if (response.status == 200) {
            context.commit('grupos/actDeleteListGrupos', grupo_id, { root: true })
           }
           return response;
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}

export async function getOrdenGrupo(context, [access_token, grupo_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'GET',
                url: '/ordenGrupo',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: {
                    grupo_id
                }
            })
            if (response.status == 200) {
               context.commit('grupos/setOrdenGrupo', response.data, { root: true })
            }
            return response;
        }

    } catch (e) {
    } finally {
       
    }
}

export async function cambiarOrdenGrupo(context, [access_token, grupo_id, punto_id, proveedor_id, accion]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/cambiarOrdenGrupo',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    grupo_id,
                    punto_id,
                    proveedor_id,
                    accion
                }
            })
          
            return response;
        }

    } catch (e) {
    } finally {
       
    }
}






